export const environment = {
  production: true,
  apiUrl: "https://www.myxgl.org/XGLnet/api/",
  traduccion: "/assets/i18n/",
  title: "MyXGL",
  titleHidden: "TitleHidden",
  trackUserActivity: true,    // ON en prod
  trackSampleRate: 1,         // 100% (o 0.2 si quieres muestrear)
};